const blocks = [
    {
        index: '837d10945aef2aed8678cbd3',
        type: 'CUSTOMIZED_BLOCK',
        title: 'ccfwpTbiYg/e',
        thumbnailUrl: null as null,
        content: {
            columnNum: 3,
            backgroundColor: '#dbf4f4',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 32,
            paddingBottom: 32,
            structureLocked: false,
            columns: [
                {
                    columnIdx: 'e2e2e519274719c1d7fc6ffd8c99bece',
                    size: 0.3333333333333333,
                    columnItems: [
                        {
                            elmIdx: '7292da6b5e05fec7a4ffaddc2ffe61062aae',
                            type: 'IMAGE',
                            content: {
                                href: '',
                                src: 'https://app-data-legacy.bananatag.com/pikasso-preview/images/1.png',
                                aspectRatio: 4.580152671755725,
                                alt: '',
                                paddingTop: 0,
                                paddingRight: 40,
                                paddingLeft: 0,
                                paddingBottom: 0,
                                mimetype: 'image/png',
                            },
                        },
                    ],
                },
                {
                    columnIdx: '8140c1352a0a59bc22881913f0f2ed24',
                    size: 0.3333333333333333,
                    columnItems: [
                        {
                            elmIdx: 'c7b0f1d46d8f09ffaddaf0bc3946390d491b',
                            type: 'SPACER',
                            content: {
                                containerBackgroundColor: '#dbf4f4',
                                height: 10,
                            },
                        },
                    ],
                },
                {
                    columnIdx: 'cf22a8e4af71f5fdcb9eec2ed8edff57',
                    size: 0.3333333333333333,
                    columnItems: [
                        {
                            elmIdx: 'bc80967b4862ba921259856f969c26e716b7',
                            type: 'SPACER',
                            content: {
                                containerBackgroundColor: '#dbf4f4',
                                height: 10,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '191f5c912ac8a14a7724e9a2',
        type: 'CUSTOMIZED_BLOCK',
        title: 'FdNmW+bFtwox',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 0,
            paddingBottom: 0,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '84ea5bebc035f74c147ad0e77d8f89f3',
                    size: 1,
                    columnItems: [
                        {
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue: '<p><span style="color: rgb(85,81,96);">January 1, 2021</span></p>\n',
                                align: 'left',
                                fontFamily: 'Helvetica',
                                fontSize: '16px',
                                lineHeight: '24px',
                                paddingTop: 50,
                                paddingRight: 40,
                                paddingLeft: 40,
                                paddingBottom: 5,
                            },
                            elmIdx: 'f7ae3400ad8acfd367b7314745ba44475097',
                        },
                        {
                            elmIdx: 'b4d91f325f7d236a38458ee6234d12050c78',
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<h2><span style="color: rgb(25,19,57);"><strong>Make your employee newsletters with Bananatag</strong></span></h2>\n',
                                align: 'left',
                                fontFamily: 'Helvetica',
                                fontSize: '20px',
                                lineHeight: '42.8571px',
                                paddingTop: 0,
                                paddingRight: 40,
                                paddingLeft: 40,
                                paddingBottom: 0,
                            },
                        },
                        {
                            elmIdx: 'c2cf919144c66499d5a56930642231f76835',
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<p><span style="color: #555160;background-color: rgb(255,255,255);">Everything is easy to customize, no design experience required</span></p>\n',
                                align: 'left',
                                fontFamily: 'Helvetica',
                                fontSize: '16px',
                                lineHeight: '24px',
                                paddingTop: 5,
                                paddingRight: 40,
                                paddingLeft: 40,
                                paddingBottom: 10,
                            },
                        },
                        {
                            elmIdx: '0e5f4beaa73b89734a0e22bb0fe1bc2f7f47',
                            type: 'IMAGE',
                            content: {
                                href: '',
                                src: 'https://app-data-legacy.bananatag.com/pikasso-preview/images/2.png',
                                aspectRatio: 1.5,
                                alt: '',
                                paddingTop: 20,
                                paddingRight: 40,
                                paddingLeft: 40,
                                paddingBottom: 0,
                                mimetype: 'image/png',
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: 'a7e3df46a9c14dd8a83e8466',
        type: 'CUSTOMIZED_BLOCK',
        title: 'bPydHVa0TZ13',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 20,
            paddingBottom: 0,
            structureLocked: false,
            columns: [
                {
                    columnIdx: 'fe99124bed7f0012297993a33e7acfdd',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '9b864f3c9d0c0ac2f8f380c4ab8117beb792',
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<p><span style="color: rgb(85,81,96);">Start with a template like this one. Clean and professional, yet easily adaptable to your brand and content needs. If you’re looking for something different, Bananatag offers a variety of email templates or you can create your own from scratch. There is no limit to what you can build.</span></p>\n<p></p>\n<p><span style="color: rgb(85,81,96);">Go ahead, give it a try! You’ll see that every block and element is not only customizable, but also mobile-friendly. That means your email will look professional and on-brand on every device.</span></p>\n',
                                align: 'left',
                                fontFamily: 'Helvetica',
                                fontSize: '16px',
                                lineHeight: '24px',
                                paddingTop: 10,
                                paddingRight: 40,
                                paddingLeft: 40,
                                paddingBottom: 0,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '455ec5e8b1f24f4168e817e6',
        type: 'CUSTOMIZED_BLOCK',
        title: 'Thumbs Up/Down Survey',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 20,
            paddingBottom: 40,
            structureLocked: false,
            columns: [
                {
                    columnIdx: 'f6a60440c51e38c7c9ce179b911b35b7',
                    size: '1',
                    columnItems: [
                        {
                            elmIdx: '7b952946a8825756a06f20603744c6b41437',
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<p><span style="color: rgb(25,19,57);"><strong>Gather feedback from employees with Pulse Surveys</strong></span></p>\n',
                                align: 'center',
                                fontFamily: 'Helvetica',
                                fontSize: '16px',
                                lineHeight: '16px',
                                paddingTop: 10,
                                paddingRight: 10,
                                paddingLeft: 10,
                                paddingBottom: 10,
                                type: 'PARAGRAPH',
                            },
                        },
                        {
                            elmIdx: '9b3f15fb12cb7afd4df67758f74f9e52a88b',
                            type: 'SURVEY',
                            content: {
                                type: 'PULSE_BINARY_THUMBS_UP_AND_DOWN',
                                iconSize: 35,
                                surveyTitle: 'Replace this text with a survey question',
                                allowComments: true,
                                iconImages: {
                                    SOCIAL_REACTION_EMOJI: {
                                        LOVE: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/love-1.png',
                                        LIKE: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/like-1.png',
                                        LAUGHING:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/laughing.png',
                                        SURPRISE:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/surprise.png',
                                        SAD: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/sad.png',
                                        ANGRY: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/angry.png',
                                    },
                                    SOCIAL_REACTION_LIKE:
                                        'https://app-data-legacy.bananatag.com/templates/images/surveys/pulse/new/thumbs_up.png',
                                    PULSE_RANGE_STARS:
                                        'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/star.png',
                                    PULSE_RANGE_FACES: {
                                        VERY_UNHAPPY:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/very-unhappy.png',
                                        UNHAPPY:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/unhappy.png',
                                        INDIFFERENT:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/indifferent.png',
                                        HAPPY: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/happy.png',
                                        VERY_HAPPY:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/very-happy.png',
                                    },
                                    PULSE_RANGE_NUMBERS: {
                                        1: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/1.png',
                                        2: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/2.png',
                                        3: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/3.png',
                                        4: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/4.png',
                                        5: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/5.png',
                                    },
                                    PULSE_BINARY_THUMBS_UP_AND_DOWN: {
                                        THUMBS_UP:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/thumbs_up.png',
                                        THUMBS_DOWN:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/thumbs_down.png',
                                    },
                                    PULSE_BINARY_YES_AND_NO: {
                                        YES: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/yes-square.png',
                                        NO: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/no-square.png',
                                    },
                                    PULSE_BINARY_CHECKBOX_CONFIRM: {
                                        YES: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/checked.png',
                                        NO: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/unchecked.png',
                                    },
                                    ENPS: {
                                        0: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/0.png',
                                        1: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/1.png',
                                        2: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/2.png',
                                        3: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/3.png',
                                        4: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/4.png',
                                        5: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/5.png',
                                        6: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/6.png',
                                        7: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/7.png',
                                        8: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/8.png',
                                        9: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/9.png',
                                        10: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/10.png',
                                    },
                                },
                                paddingTop: 10,
                                paddingRight: 10,
                                paddingLeft: 10,
                                paddingBottom: 10,
                            },
                        },
                        {
                            elmIdx: '0b3c054c29521b46ec867ad17787ac34531a',
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<p><span style="color: rgb(29,28,29);background-color: rgb(255,255,255);">Customize survey types, response scales, and allow comments</span></p>\n',
                                align: 'center',
                                fontFamily: 'Arial',
                                fontSize: '12px',
                                lineHeight: '18px',
                                paddingTop: 0,
                                paddingRight: 40,
                                paddingLeft: 40,
                                paddingBottom: 0,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '49c9659f39a489e8dc5f7cb0',
        type: 'CUSTOMIZED_BLOCK',
        title: 'bI20Ybxgh9Li',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#dbf4f4',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '5de8ed83090763604202c8c22b711934',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '09ddc8429814351ec3f53c52f2426abcbd88',
                            type: 'SPACER',
                            content: {
                                containerBackgroundColor: '#dbf4f4',
                                height: 10,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '11add5be5fceaf28afea5cab',
        type: 'CUSTOMIZED_BLOCK',
        title: 'DxCvw01zar+c',
        thumbnailUrl: null as null,
        content: {
            columnNum: 3,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 40,
            paddingBottom: 0,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '4fb98ff6ec8e21db3dc89e7ba055601f',
                    size: 0.3333333333333333,
                    columnItems: [
                        {
                            elmIdx: '352b30715e6db7c7e742a734698e2b039a2f',
                            type: 'IMAGE',
                            content: {
                                href: '',
                                src: 'https://app-data-legacy.bananatag.com/pikasso-preview/images/3.png',
                                aspectRatio: 1,
                                alt: '',
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingLeft: 40,
                                paddingBottom: 10,
                                mimetype: 'image/jpeg',
                            },
                        },
                    ],
                },
                {
                    columnIdx: '1d9fcafd9384f95bebd9476125e4d4c6',
                    size: 0.3333333333333333,
                    columnItems: [
                        {
                            elmIdx: 'fb0a2742b8a20ec4f0c706ac1d2b425408ef',
                            type: 'IMAGE',
                            content: {
                                href: '',
                                src: 'https://app-data-legacy.bananatag.com/pikasso-preview/images/4.png',
                                aspectRatio: 1,
                                alt: '',
                                paddingTop: 0,
                                paddingRight: 20,
                                paddingLeft: 20,
                                paddingBottom: 10,
                                mimetype: 'image/jpeg',
                            },
                        },
                    ],
                },
                {
                    columnIdx: '9f970c8e43ab3fd53d39a9290d4e711a',
                    size: 0.3333333333333333,
                    columnItems: [
                        {
                            elmIdx: 'bf728fca3217ac966905b899ec0fae5d8d79',
                            type: 'IMAGE',
                            content: {
                                href: '',
                                src: 'https://app-data-legacy.bananatag.com/pikasso-preview/images/5.jpeg',
                                aspectRatio: 1,
                                alt: '',
                                paddingTop: 0,
                                paddingRight: 40,
                                paddingLeft: 0,
                                paddingBottom: 10,
                                mimetype: 'image/jpeg',
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '6efc442948db638452038d43',
        type: 'CUSTOMIZED_BLOCK',
        title: 'W2d3OhcdfCBm',
        thumbnailUrl: null as null,
        content: {
            columnNum: 3,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 3,
            paddingBottom: 0,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '3b4c552012ed32d52bda22998f9d5118',
                    size: 0.3333333333333333,
                    columnItems: [
                        {
                            elmIdx: 'c591d1341acaef6894edce34c91c16aa13c6',
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<p><span style="color: rgb(25,19,57);"><strong>Build Multi</strong></span></p>\n',
                                align: 'center',
                                fontFamily: 'Helvetica',
                                fontSize: '16px',
                                lineHeight: '24px',
                                paddingTop: 0,
                                paddingRight: 10,
                                paddingLeft: 40,
                                paddingBottom: 0,
                            },
                        },
                    ],
                },
                {
                    columnIdx: '9d50e69e14fb8bc59ac6a83f221b5846',
                    size: 0.3333333333333333,
                    columnItems: [
                        {
                            elmIdx: '2e09f4ae5d34c1aa9d0a73a43b4927f0eea6',
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<p><span style="color: rgb(25,19,57);"><strong>Column</strong></span></p>\n',
                                align: 'center',
                                fontFamily: 'Helvetica',
                                fontSize: '16px',
                                lineHeight: '24px',
                                paddingTop: 0,
                                paddingRight: 10,
                                paddingLeft: 10,
                                paddingBottom: 0,
                            },
                        },
                    ],
                },
                {
                    columnIdx: '4d377c2e9707af34e565a6c9658f26cd',
                    size: 0.3333333333333333,
                    columnItems: [
                        {
                            elmIdx: '4630dce62f2373643019a06cce7d287a3616',
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<p><span style="color: rgb(25,19,57);"><strong>Designs!</strong></span></p>\n',
                                align: 'center',
                                fontFamily: 'Helvetica',
                                fontSize: '16px',
                                lineHeight: '24px',
                                paddingTop: 0,
                                paddingRight: 40,
                                paddingLeft: 10,
                                paddingBottom: 0,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: 'fb8768c28f2f2f21b7b80cfe',
        type: 'CUSTOMIZED_BLOCK',
        title: '4kxsR0WQzXNr',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 20,
            paddingBottom: 40,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '36a15fa93d350a953f020b5e5d3c3b5e',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '0468bdfec5f2d03ffcf441c8eaf42530331a',
                            type: 'IMAGE',
                            content: {
                                href: '',
                                src: 'https://app-data-legacy.bananatag.com/pikasso-preview/images/6.gif',
                                aspectRatio: 7.339449541284404,
                                alt: '',
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingLeft: 0,
                                paddingBottom: 0,
                                mimetype: 'image/gif',
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '275e957602d385ead8b9042b30891e811f0f',
        type: 'CUSTOMIZED_BLOCK',
        title: 'bI20Ybxgh9Li',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#dbf4f4',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: 'b29f7d521872f206d790e3c553aaed3c',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '275e957602d385ead8b9042b30891e811f0f',
                            type: 'SPACER',
                            content: {
                                containerBackgroundColor: '#dbf4f4',
                                height: 10,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: 'b31b47cc29aba72671f21c31',
        type: 'CUSTOMIZED_BLOCK',
        title: '116IA96Q7ZC1',
        thumbnailUrl: null as null,
        content: {
            columnNum: 2,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 30,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: 'e7d365082f5a8d7153fb42c10cc85fc3',
                    size: 0.5,
                    columnItems: [
                        {
                            type: 'IMAGE',
                            content: {
                                href: '',
                                src: 'https://app-data-legacy.bananatag.com/pikasso-preview/images/7.png',
                                aspectRatio: 1.3321492007104796,
                                alt: '',
                                paddingTop: 10,
                                paddingRight: 10,
                                paddingLeft: 40,
                                paddingBottom: 10,
                                mimetype: 'image/jpeg',
                            },
                            elmIdx: '9a79db8faa10e4c7ac65b8e26446a1594de4',
                        },
                    ],
                },
                {
                    columnIdx: '778bdc8ccbb2ae0f01120e9ce0661a4a',
                    size: 0.5,
                    columnItems: [
                        {
                            elmIdx: 'b554766cbcd0de61d19f4743868d73d88895',
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<p><span style="color: rgb(29,28,29);background-color: rgb(255,255,255);">There are a lot of great ways to lay out content in our Email Designer. We recommend keeping things short and sweet, while providing links to more in-depth content</span></p>\n',
                                align: 'left',
                                fontFamily: 'Helvetica',
                                fontSize: '16px',
                                lineHeight: '24px',
                                paddingTop: 10,
                                paddingRight: 40,
                                paddingLeft: 20,
                                paddingBottom: 10,
                            },
                        },
                        {
                            elmIdx: 'c3df438eda86bbb6c5f1eee9d76c182b2ec7',
                            type: 'BUTTON',
                            content: {
                                text: 'Sharepoint link',
                                href: '',
                                align: 'left',
                                fontFamily: 'Arial',
                                fontSize: '16px',
                                lineHeight: '16px',
                                fontStyle: 'normal',
                                fontWeight: 'bold',
                                textDecoration: 'none',
                                color: '#191339',
                                backgroundColor: '#ff9100',
                                borderRadius: 8,
                                innerHorizontalPadding: 50,
                                innerVerticalPadding: 12,
                                paddingTop: 10,
                                paddingRight: 10,
                                paddingLeft: 20,
                                paddingBottom: 10,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '4c813e5ddd157201b80238f9',
        type: 'CUSTOMIZED_BLOCK',
        title: 'IVh89uLzHJar',
        thumbnailUrl: null as null,
        content: {
            columnNum: 2,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 0,
            paddingBottom: 30,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '69949d5670e15295bfb66d5bdd5eb183',
                    size: 0.5,
                    columnItems: [
                        {
                            elmIdx: 'a85da65284fe4a308671f437794ebaf236b2',
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<p><span style="color: rgb(29,28,29);background-color: rgb(255,255,255);">You’ll be able to see how many employees click each link and other engagement metrics, so you can keep improving your content over time.</span></p>\n',
                                align: 'left',
                                fontFamily: 'Helvetica',
                                fontSize: '16px',
                                lineHeight: '24px',
                                paddingTop: 10,
                                paddingRight: 10,
                                paddingLeft: 40,
                                paddingBottom: 10,
                            },
                        },
                        {
                            elmIdx: 'ba2643d8d5fdac38704d740b33bab0670799',
                            type: 'BUTTON',
                            content: {
                                text: 'Link to new policy',
                                href: '',
                                align: 'left',
                                fontFamily: 'Arial',
                                fontSize: '16px',
                                lineHeight: '16px',
                                fontStyle: 'normal',
                                fontWeight: 'bold',
                                textDecoration: 'none',
                                color: '#191339',
                                backgroundColor: '#ff9100',
                                borderRadius: 8,
                                innerHorizontalPadding: 50,
                                innerVerticalPadding: 12,
                                paddingTop: 10,
                                paddingRight: 10,
                                paddingLeft: 40,
                                paddingBottom: 10,
                            },
                        },
                    ],
                },
                {
                    columnIdx: 'd426ae18c5ee56c1ae993526b6b7d90e',
                    size: 0.5,
                    columnItems: [
                        {
                            type: 'IMAGE',
                            content: {
                                href: '',
                                src: 'https://app-data-legacy.bananatag.com/pikasso-preview/images/8.png',
                                aspectRatio: 1.3333333333333333,
                                alt: '',
                                paddingTop: 10,
                                paddingRight: 40,
                                paddingLeft: 10,
                                paddingBottom: 10,
                                mimetype: 'image/jpeg',
                            },
                            elmIdx: 'e17faa7088b0d11b7f0bc7e329e50f789e87',
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '0b656c9d815355c63b99e6c4b6e0658fb508',
        type: 'CUSTOMIZED_BLOCK',
        title: 'bI20Ybxgh9Li',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#dbf4f4',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: 'e87bff7e2774facdd9c7811deec9df8a',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '0b656c9d815355c63b99e6c4b6e0658fb508',
                            type: 'SPACER',
                            content: {
                                containerBackgroundColor: '#dbf4f4',
                                height: 10,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '3f607e04e7bf750c032ff88c',
        type: 'CUSTOMIZED_BLOCK',
        title: 'Social Reactions Survey',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '1d43a6cd57bfbd7bee2e6d99a75a38d3',
                    size: '1',
                    columnItems: [
                        {
                            elmIdx: 'a6255b31dbd31e6cfaa4a4685ecb7dda2e67',
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<p><span style="color: rgb(25,19,57);"><strong>How likely are you to recommend ACME as a great place to work?</strong></span></p>\n',
                                align: 'center',
                                fontFamily: 'Helvetica',
                                fontSize: '16px',
                                lineHeight: '24px',
                                paddingTop: 5,
                                paddingRight: 40,
                                paddingLeft: 40,
                                paddingBottom: 9,
                                type: 'PARAGRAPH',
                            },
                        },
                        {
                            elmIdx: '2d13163588d47be21648c91fccc51f3225c9',
                            type: 'SURVEY',
                            content: {
                                type: 'ENPS',
                                iconSize: 25,
                                surveyTitle: 'Replace this text with a survey question',
                                allowComments: false,
                                iconImages: {
                                    SOCIAL_REACTION_EMOJI: {
                                        LOVE: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/love-1.png',
                                        LIKE: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/like-1.png',
                                        LAUGHING:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/laughing.png',
                                        SURPRISE:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/surprise.png',
                                        SAD: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/sad.png',
                                        ANGRY: 'https://app-data-legacy.bananatag.com/templates/images/surveys/surveyBlock/new/angry.png',
                                    },
                                    SOCIAL_REACTION_LIKE:
                                        'https://app-data-legacy.bananatag.com/templates/images/surveys/pulse/new/thumbs_up.png',
                                    PULSE_RANGE_STARS:
                                        'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/star.png',
                                    PULSE_RANGE_FACES: {
                                        VERY_UNHAPPY:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/very-unhappy.png',
                                        UNHAPPY:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/unhappy.png',
                                        INDIFFERENT:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/indifferent.png',
                                        HAPPY: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/happy.png',
                                        VERY_HAPPY:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/very-happy.png',
                                    },
                                    PULSE_RANGE_NUMBERS: {
                                        1: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/1.png',
                                        2: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/2.png',
                                        3: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/3.png',
                                        4: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/4.png',
                                        5: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/5.png',
                                    },
                                    PULSE_BINARY_THUMBS_UP_AND_DOWN: {
                                        THUMBS_UP:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/thumbs_up.png',
                                        THUMBS_DOWN:
                                            'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/new/thumbs_down.png',
                                    },
                                    PULSE_BINARY_YES_AND_NO: {
                                        YES: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/yes-square.png',
                                        NO: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/no-square.png',
                                    },
                                    PULSE_BINARY_CHECKBOX_CONFIRM: {
                                        YES: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/checked.png',
                                        NO: 'https://app-data-legacy.bananatag.com/templates/images/surveys/pulseSurveyBlock/unchecked.png',
                                    },
                                    ENPS: {
                                        0: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/0.png',
                                        1: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/1.png',
                                        2: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/2.png',
                                        3: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/3.png',
                                        4: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/4.png',
                                        5: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/5.png',
                                        6: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/6.png',
                                        7: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/7.png',
                                        8: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/8.png',
                                        9: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/9.png',
                                        10: 'https://app-data-legacy.bananatag.com/templates/images/surveys/npsBlock/new/10.png',
                                    },
                                },
                                paddingTop: 10,
                                paddingRight: 40,
                                paddingLeft: 40,
                                paddingBottom: 10,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '3a5c64174cfb4656b19dfe504681cdc8ad66',
        type: 'CUSTOMIZED_BLOCK',
        title: 'bI20Ybxgh9Li',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#dbf4f4',
            wrapperBackgroundColor: '#dbf4f4',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: 'c1f4c53937260e8cc4c738bcf90bdb73',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '3a5c64174cfb4656b19dfe504681cdc8ad66',
                            type: 'SPACER',
                            content: {
                                containerBackgroundColor: '#dbf4f4',
                                height: 10,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: 'b087eddc032e729e516b2b07561bdfd6dbf4',
        type: 'CUSTOMIZED_BLOCK',
        title: 'bI20Ybxgh9Li',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#5ec2d7',
            wrapperBackgroundColor: '#5ec2d7',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '71aa1ffcb8acdedc00821eac3ab418f3',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: 'b087eddc032e729e516b2b07561bdfd6dbf4',
                            type: 'SPACER',
                            content: {
                                containerBackgroundColor: '#5ec2d7',
                                height: 10,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '3530a4b1702b8785e5994913',
        type: 'CUSTOMIZED_BLOCK',
        title: 'Social links',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#9ed9dd',
            wrapperBackgroundColor: '#5ec2d7',
            paddingTop: 0,
            paddingBottom: 0,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '52b20b99e178e6deb6dcf73afe6a56eb',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: 'a8d5471dcc8f9d79466e9d7a35365671839e',
                            type: 'SOCIAL',
                            content: {
                                align: 'center',
                                iconSize: 28,
                                iconVersionColor: false,
                                icons: [
                                    {
                                        title: 'instagram',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-instagram.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-instagram.png',
                                        },
                                        href: '',
                                        active: true,
                                    },
                                    {
                                        title: 'twitter',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-twitter.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-twitter.png',
                                        },
                                        href: '',
                                        active: true,
                                    },
                                    {
                                        title: 'youtube',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-youtube.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-youtube.png',
                                        },
                                        href: '',
                                        active: true,
                                    },
                                    {
                                        title: 'facebook',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-facebook.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-facebook.png',
                                        },
                                        href: '',
                                        active: true,
                                    },
                                    {
                                        title: 'email',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-email.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-email.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'flickr',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-flickr.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-flickr.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'glassdoor',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-glassdoor.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-glassdoor.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'pinterest',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-pinterest.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-pinterest.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'slack',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-slack.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-slack.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'vimeo',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-vimeo.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-vimeo.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'website',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-website.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-website.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'wechat',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-wechat.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-wechat.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'weibo',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-weibo.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-weibo.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'workplace',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-workplace.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-workplace.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'yammer',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-yammer.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-yammer.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'microsoft-teams',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-microsoft-teams.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-microsoft-teams.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'tiktok',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-tiktok.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-tiktok.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'Bananatag',
                                        src: {
                                            color: 'https://bt-user-data-us-west-2.s3.us-west-2.amazonaws.com/tZWWz2/customization/icons/Bananatag.png',
                                            bw: 'https://bt-user-data-us-west-2.s3.us-west-2.amazonaws.com/tZWWz2/customization/icons/Bananatag.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                    {
                                        title: 'linkedin',
                                        src: {
                                            color: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-color-linkedin.png',
                                            bw: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/social/icon-social-linkedin.png',
                                        },
                                        href: '',
                                        active: false,
                                    },
                                ],
                                paddingTop: 10,
                                paddingRight: 10,
                                paddingLeft: 10,
                                paddingBottom: 0,
                            },
                        },
                        {
                            type: 'PARAGRAPH',
                            content: {
                                textMarkupValue:
                                    '<p><span style="color: rgb(114,114,115);"><strong>#yourcompanyhashtag</strong></span></p>\n',
                                align: 'center',
                                fontFamily: 'Helvetica',
                                fontSize: '18px',
                                lineHeight: '18px',
                                paddingTop: 5,
                                paddingRight: 10,
                                paddingLeft: 10,
                                paddingBottom: 20,
                            },
                            elmIdx: '3d77aa0a0ff5fc6dd2e444c462b91222bca0',
                        },
                    ],
                },
            ],
        },
    },
    {
        index: '2ba59270834d92353067061e2706b013508b',
        type: 'CUSTOMIZED_BLOCK',
        title: 'bI20Ybxgh9Li',
        thumbnailUrl: null as null,
        content: {
            columnNum: 1,
            backgroundColor: '#5ec2d7',
            wrapperBackgroundColor: '#5ec2d7',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: 'cf7c304005015adb0fcac1ae58874be4',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '2ba59270834d92353067061e2706b013508b',
                            type: 'SPACER',
                            content: {
                                containerBackgroundColor: '#5ec2d7',
                                height: 10,
                            },
                        },
                    ],
                },
            ],
        },
    },
];

export default blocks;
